<ion-item>

  <ion-label>
    <div class="title">{{ 'ITEMS.FINANCES.PENDING' | translate }}</div>
  </ion-label>

  <ion-note slot="end">
    {{ (pending | currency: 'EUR': 'symbol': '1.2-2': 'es') || '- €' }}
  </ion-note>

</ion-item>

<ion-item>

  <ion-label>
    <div class="title">{{ 'ITEMS.FINANCES.PAID' | translate }}</div>
  </ion-label>

  <ion-note slot="end">
    {{ (pay | currency: 'EUR': 'symbol': '1.2-2': 'es') || '- €' }}
  </ion-note>

</ion-item>

<ion-item>

  <ion-label>
    <div class="title">{{ 'ITEMS.FINANCES.TOTAL' | translate }}</div>
  </ion-label>

  <ion-note class="total" slot="end">
    {{ (total | currency: 'EUR': 'symbol': '1.2-2': 'es') || '- €' }}
  </ion-note>

</ion-item>
